import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { TextField } from '@mui/material';
import Box from '@mui/material/Box';
import "./FinacialAnalytics.css";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import FinancialAnalytics from './FinancialAnalytics';
import JobMetrics from "./JobMetrics";
import NewZScore from './NewZScore';
import PMDashboard from './PMDashboard';
import SupportingDocuments from './SupportingDocuments';
import apiinfo from '../../../utils/base-uri.json';
import axios from "../../../utils/fvAxios";
import { useEffect, useState, useRef } from "react";
import { useForm } from 'react-hook-form';
import { Grid, Autocomplete } from '@mui/material'
import OutlinedInput from '@mui/material/OutlinedInput';
import { getGlobalClientId, getOrgType } from "../../../utils/Token";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Nodata from "../../../pages/Nodata/Nodata";
import { RFC_2822 } from 'moment';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function FInacialAnalyticsTabs() {


  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const [age, setAge] = React.useState('');

  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");
  const CLIENTID = params.get("clientid");
  const VENDORID = params.get("vendorId");
  const VENDORNAME = params.get("vname");
  const ID = params.get("ID");
  const [premission, sethaspermission] = useState();

  // console.log(PQID, CLIENTID, VENDORID, ID);

  const handleChange = (event, newValue) => {
    setAge(event.target.value);
    setValue(newValue)
  };
  const [value, setValue] = React.useState(!premission?3:0);

  const [error, setError] = useState(null);
  useEffect(() => {
    if(premission){
    setValue(0)}
    
  }, [premission]);


  const [vendor, setVendor] = useState([]);
  const [client, setClient] = React.useState([]);
  const [period, setPeriod] = React.useState([],);
  const [fincialdata, setFincialdata] = React.useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [jobMetrics, setJobmetrics] = useState([]);
  const [Supportdoc, setSupportdoc] = useState([]);
  const [zscore, setZscore] = useState([]);
  const [PmDashboard, setPMDashboard] = useState([]);
  const [count, setCount] = React.useState("");

  const [clientID, setClientID] = useState("");
  const [vendorID, setVendorID] = useState("");
  const [periodID, setPeriodID] = useState("");
  const [deFault, setDeFault] = useState({});



  useEffect(() => {
    axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false"
    ).then((res) => {
      setClient(res?.data?.data)
      if(getOrgType()=="Client"){
        setClientID(res?.data?.data[0]?.value)
      }
    })
    if (ID == 1) {
      changeClients(CLIENTID);
      changeVendors(CLIENTID, VENDORID);
      ChangePeriod(CLIENTID, VENDORID, PQID);

      // setDeFault({ key: VENDORID, value: VENDORNAME });
    }
  }, []);
  useEffect(() => {
    axios.get("Prequalification/HasRestrictedSectionAccess"
    ).then((res) => {
      sethaspermission(res?.data?.data);
    
    })
    
  }, []);

  const [text, setText] = useState("");

  const changeClients = (e) => {
    setClientID(e);
    setFincialdata([]);
    setPeriod([]);
    setVendor([]);
    setText(1);
    changeVendors("", "");
    
    
  }


  const Information = { key: VENDORID, value: VENDORNAME }
  const Information1 = { key: "", value: "" }
  const Getvendors = (e) => {
    //setText(e);
    setPeriod([]);
    axios.get(apiinfo.FinancialAnalytics.GetVendorsByClient + "clientId=" + clientID + "&freeText=" + e)
      .then((res) => {
        setVendor(res?.data?.data)
      })
  }

  const changeVendors = (cl, value) => {
    console.log(value);
    setFincialdata([]);
    if (value) {
      const Clien = cl == "" ? clientID : cl;
      setVendorID(value);
      axios.get(apiinfo.FinancialAnalytics.GetprequalificationPeriods + "clientId=" + Clien + "&vendorId=" + value)
        .then((res) => {
          setPeriod(res?.data?.data)
        }).catch(err => {
          toastNotify(err, false)
        })
    }
  }

  const ChangePeriod = (cl, ve, e) => {
    const Clien = cl == "" ? clientID : cl;
    const vende = ve == "" ? vendorID : ve;
    setPeriodID(e);
    axios.get(apiinfo.FinancialAnalytics.GetFinancialAnalytics + "clientId=" + Clien + "&vendorId=" + vende + "&PqId=" + e,
    ).then(res => {
      setCount(res?.data?.count);
      if (res?.data?.count > 0) {
        setFincialdata(res?.data?.data);
      }
      else {
        // toastNotify("Data not found",false)
      }
    }).catch(err => {
      toastNotify(err, false)
    })

    axios.get("Prequalification/GetJobMetrics?clientId=" + Clien + "&vendorId=" + vende + "&PqId=" + e,
    ).then((res) => {
      if (res?.data?.responseCode === 100) {
        setJobmetrics(res?.data?.data);
      }
      else {
        // toastNotify("Data not found", false)
      }
    }).catch(err => {
      //console.log(err)
    }).finally(() => {
      setIsLoading(false);
    })

    axios.get("Prequalification/GetNewZScore?clientId=" + Clien + "&vendorId=" + vende + "&PqId=" + e,
    ).then((res) => {
      if (res?.data?.responseCode === 100) {
        setZscore(res?.data?.data);
      }
      else {
        // toastNotify("Data not found", false)
      }
    }).catch(err => {
      //console.log(err)
    }).finally(() => {
      setIsLoading(false);
    });

    axios.get("Prequalification/GetSupportingDocumentsForFA?clientId=" + Clien + "&vendorId=" + vende + "&PqId=" + e,
    ).then((res) => {
      if (res?.data?.responseCode === 100) {
        setSupportdoc(res?.data?.data);
        debugger;
      }
      else {
        // toastNotify("Data not found", false)
      }
    }).catch(err => {
      //console.log(err)
    }).finally(() => {
      setIsLoading(false);
    });

    axios.get("Prequalification/GetPMDashboard?clientId=" + Clien + "&vendorId=" + vende + "&PqId=" + e,
    ).then((res) => {
      if (res?.data?.responseCode === 100) {
        setPMDashboard(res?.data?.data);
      }
      else {
        // toastNotify("Data not found", false)
      }
    }).catch(err => {
      //console.log(err)
    }).finally(() => {
      setIsLoading(false);
    });

  };


  return (

    <>
      <div style={{ padding: "20px" }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <ToastContainer />
          <Grid item xs={12} sm={12} md={6} >
            <span style={{ fontSize: '28px', fontWeight: "600px", marginTop: "20px" }}>Financial Analytics</span>
          </Grid>
          <Grid item xs={12} sm={12} md={2} >
            <FormControl sx={{ m: 1, width: 200 }}>
              {/* <InputLabel id="demo-multiple-name-label" sx={{ marginTop: "-5px", }}>Select Client</InputLabel> */}
              <span > Select Client</span>
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                value={clientID}
                size="small"
                onChange={(e) => changeClients(e.target.value, "")}
                // input={<OutlinedInput label="Select Client" value={selectValue1} />}
                MenuProps={MenuProps}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
              >
                {client?.map((item, index) => (
                  <MenuItem key={index} value={item.value} title={item.text}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>



          <Grid item xs={12} sm={12} md={2} >
            <FormControl sx={{ m: 1, width: 200 }}>
              <span >Select Vendor</span>
              <Autocomplete
                getOptionLabel={(vendor) => `${vendor?.value}`}
                options={vendor}
                freeSolo
                size="small"
                defaultValue={ID == 1 ? Information : Information1}
                onChange={(event, value) => changeVendors("", value?.key)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // label="Select Vendor"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    variant="outlined"
                    fullWidth
                    onChange={(e) => Getvendors(e?.target.value)}
                  />
                )}
              />

            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={2} >
            <FormControl sx={{ m: 1, width: 200 }}>
              {/* <InputLabel id="demo-multiple-name-label" sx={{ marginTop: "-5px" }}>Select Period</InputLabel> */}
              <span> Select Period</span>
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                value={periodID}
                size="small"
                onChange={(e) => ChangePeriod("", "", e.target.value)}
                // input={<OutlinedInput label="Select Period" value={selectValue2} />}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                MenuProps={MenuProps}
              >
                {period?.map((item, index) => (
                  <MenuItem style={{ maxwidth: "30px" }} key={index} value={item.key} title={item.value}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

        </Grid>
      </div>
      <Tabs
        className='mt-2'
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
      >
        <Tab label="Financial Analytics"  {...a11yProps(0)}  hidden={!premission} style={{ textTransform: "inherit" }} />
        <Tab label="Job Metrics"  {...a11yProps(1)}  hidden={!premission} style={{ textTransform: "inherit" }} />
        <Tab label="New Z score"  {...a11yProps(1)}  hidden={!premission}style={{ textTransform: "inherit" }} />
        <Tab label="PM Dashboard"  {...a11yProps(1)} style={{ textTransform: "inherit" }} />
        <Tab label="Supporting Documents"  {...a11yProps(1)} style={{ textTransform: "inherit" }} />
      </Tabs>
      <div >
        <div hidden={!premission}> 
        <TabPanel value={value} index={0}>
          <FinancialAnalytics {...fincialdata} COUNT={count} pqid={periodID} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <JobMetrics job={jobMetrics} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <NewZScore zee={zscore} />
        </TabPanel >
        </div>
        <TabPanel value={value} index={3} >
          {PmDashboard?.length == 0 ? "" : (
            <PMDashboard pm={PmDashboard} pqID={periodID}/>)}
          <div hidden={fincialdata.length != 0}> </div>
        </TabPanel >
        <TabPanel value={value} index={4}>
          <SupportingDocuments doc={Supportdoc} />
        </TabPanel >
      </div>
      {/* <div hidden={fincialdata.length != 0}> <Nodata /></div> */}
    </>
  )
}

